export default "__VITE_ASSET__C4PdzgO7__"